import { render, staticRenderFns } from "./category-ax.vue?vue&type=template&id=46c416be&scoped=true&"
import script from "./category-ax.vue?vue&type=script&lang=js&"
export * from "./category-ax.vue?vue&type=script&lang=js&"
import style0 from "./category-ax.vue?vue&type=style&index=0&id=46c416be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c416be",
  null
  
)

export default component.exports